import { LargeListSkeleton } from '@Components/General/Skeletons'
import { createFileRoute } from '@tanstack/react-router'
import { emailsDraftsQueryOptions } from '@utils/queryOptions'
import EmailDrafts from '@Views/Emails/drafts'

export const Route = createFileRoute('/emails/drafts/')({
  component: EmailDrafts,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      emailsDraftsQueryOptions(opts.deps),
    ),
  loaderDeps: ({ search }) => search,
  pendingComponent: LargeListSkeleton,
})
